import ShopTileCard from './Tile';
import { Grid } from 'theme-ui';

const ShopTileSection = ({
  cards,
  showNewStyle,
}: {
  cards: Queries.ShopTileFragmentFragment[];
  showNewStyle: boolean;
}) => {
  const newStyle = {
    gridGap: ['2sm', null, '3md'],
  };
  return (
    <Grid
      sx={{
        gridTemplateColumns: ['1fr', `repeat(${cards.length === 2 ? 2 : 3}, minmax(min-content, 1fr))`],
        gridGap: '2.4rem',
        ...((showNewStyle && newStyle) ?? {}),
        mx: 'auto',
        maxWidth: 'var(--max-width)',
      }}
    >
      {cards.map((card) => (
        <ShopTileCard key={card.id} card={card} showNewStyle={showNewStyle} />
      ))}
    </Grid>
  );
};

export default ShopTileSection;
